'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { motion, useAnimationControls, useReducedMotion } from 'framer-motion';
import { applyLandingLanguage, useLandingLanguage } from '@/hooks/useLandingLanguage';
import { useHashScroll } from '@/hooks/useHashScroll';
import { CadrinoShell } from './shared';
import { CadrinoHeader } from './CadrinoHeader';
import { Hero } from './Hero';
import { TrustStrip } from './TrustStrip';
import { PartnersPromoSection } from './PartnersPromoSection';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { ProductShowcase } from './ProductShowcase';
import { FeaturesSection } from './FeaturesSection';
import { HowItWorks } from './HowItWorks';
import { DeploymentSection } from './DeploymentSection';
import { UseCases } from './UseCases';
import { SecuritySection } from './SecuritySection';
import { IntegrationSection } from './IntegrationSection';
import { ExplorePagesSection } from './ExplorePagesSection';
import { FaqSection } from './FaqSection';
import { SocialProofSection } from './SocialProofSection';
import { CTASection } from './CTASection';
import { CadrinoFooter } from './CadrinoFooter';
export default function CadrinoLandingPage() {
  const $ = _c(32);
  const {
    language
  } = useLandingLanguage();
  const transitionControls = useAnimationControls();
  const reducedMotion = useReducedMotion();
  useHashScroll();
  let t0;
  let t1;
  if ($[0] !== language) {
    t0 = () => {
      applyLandingLanguage(language);
    };
    t1 = [language];
    $[0] = language;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== reducedMotion || $[4] !== transitionControls) {
    t2 = () => {
      if (reducedMotion) {
        transitionControls.set({
          opacity: 1,
          y: 0
        });
        return;
      }
      let cancelled = false;
      const run = async () => {
        await transitionControls.start({
          opacity: 0.84,
          y: 3,
          transition: {
            duration: 0.1,
            ease: "easeOut"
          }
        });
        if (cancelled) {
          return;
        }
        await transitionControls.start({
          opacity: 1,
          y: 0,
          transition: {
            duration: 0.2,
            ease: "easeOut"
          }
        });
      };
      run();
      return () => {
        cancelled = true;
      };
    };
    $[3] = reducedMotion;
    $[4] = transitionControls;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== language || $[7] !== reducedMotion || $[8] !== transitionControls) {
    t3 = [language, reducedMotion, transitionControls];
    $[6] = language;
    $[7] = reducedMotion;
    $[8] = transitionControls;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CadrinoHeader />;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Hero />;
    t6 = <TrustStrip />;
    t7 = <ProblemSection />;
    t8 = <SolutionSection />;
    t9 = <ProductShowcase />;
    t10 = <FeaturesSection />;
    t11 = <HowItWorks />;
    t12 = <DeploymentSection />;
    t13 = <UseCases />;
    t14 = <SecuritySection />;
    t15 = <IntegrationSection />;
    t16 = <PartnersPromoSection />;
    t17 = <SocialProofSection />;
    t18 = <ExplorePagesSection />;
    t19 = <FaqSection />;
    t20 = <CTASection />;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
    $[14] = t13;
    $[15] = t14;
    $[16] = t15;
    $[17] = t16;
    $[18] = t17;
    $[19] = t18;
    $[20] = t19;
    $[21] = t20;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t10 = $[11];
    t11 = $[12];
    t12 = $[13];
    t13 = $[14];
    t14 = $[15];
    t15 = $[16];
    t16 = $[17];
    t17 = $[18];
    t18 = $[19];
    t19 = $[20];
    t20 = $[21];
    t5 = $[22];
    t6 = $[23];
    t7 = $[24];
    t8 = $[25];
    t9 = $[26];
  }
  let t21;
  if ($[27] !== transitionControls) {
    t21 = <motion.main initial={false} animate={transitionControls}>{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}</motion.main>;
    $[27] = transitionControls;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <CadrinoFooter />;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  let t23;
  if ($[30] !== t21) {
    t23 = <CadrinoShell>{t4}{t21}{t22}</CadrinoShell>;
    $[30] = t21;
    $[31] = t23;
  } else {
    t23 = $[31];
  }
  return t23;
}